import {
  GenericForm,
  GenericFormLogicalField,
  genericBeforeValidate_removeDefaultKeyedError,
  ValidationEvent,
  genericValidate_textField,
  GenericTextFieldValidationOptions,
  genericBeforeValidate_removeDefaultKeyedWarning,
} from "../../../hooks";

interface PostcodeFormLogicProps<
  Form extends GenericForm,
  App extends unknown
> {
  required?: boolean;

  guard?: GenericTextFieldValidationOptions<Form, App>["guard"];
}

const maxPostcodeLength = 32;

const isAValidPostcode = (postcodeValue?: string) => {
  const isAValidPostcode = postcodeValue?.match(/^[0-9]{1,5}$/);
  return !!isAValidPostcode;
};

const POSTCODE_INVALID_CUSTOM_WARNING =
  "Provided Zip/Postal Code seems to be invalid. Example: 1234. If you believe it is the right one you can ignore this notice.";

export const postcodeFormLogic = <
  Form extends GenericForm,
  App extends unknown
>(
  props: PostcodeFormLogicProps<Form, App> = {}
): GenericFormLogicalField<Form, App> => ({
  presentation: props,
  validationEvents: [
    ValidationEvent.onChange,
    ValidationEvent.onBlur,
    ValidationEvent.onSubmit,
  ],
  beforeValidate: (context) => {
    genericBeforeValidate_removeDefaultKeyedWarning(context);
    genericBeforeValidate_removeDefaultKeyedError(context);
  },
  validate: genericValidate_textField({
    required: props.required,
    maxLength: maxPostcodeLength,
    guard: props.guard,
    customWarningValidation: (value: any) => {
      if (!isAValidPostcode(value)) {
        return POSTCODE_INVALID_CUSTOM_WARNING;
      }
      return null;
    },
  }),
});
